import { createGlobalStyle } from 'styled-components'
// eslint-disable-next-line import/no-unresolved
import { BrickchainTheme } from '@pancakeswap-libs/uikit'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends BrickchainTheme {
  }
}

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Patrick Hand SC', cursive;
  }
  body {
    background-color: ${({ theme }) => theme.colors.background};

    img {
      height: auto;
      max-width: 100%;
    }
  }
`

export default GlobalStyle
